export default __webpack_public_path__ + "static/media/3.024668c5.jpg";